window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Utility collection of history related functions.
 *
 * @return {Object} Public methods of o_util.history.
 */
o_util.history = (function() {
    "use strict";

    var hasNativeScrollRestoration = ("scrollRestoration" in history),
        initialScrollRestoration = (hasNativeScrollRestoration) ? history.scrollRestoration : "auto";

    /**
     *
     * @param {String} scrollRestoration     Sets history.scrollRestoration ["auto"|"manual"]
     */
    function setScrollRestoration(scrollRestoration) {
        if (hasNativeScrollRestoration) {
            history.scrollRestoration = scrollRestoration;
        }
    }

    /**
     * Resets Scroll
     */
    function resetScrollRestoration() {
        setScrollRestoration(initialScrollRestoration);
    }

    /**
     * Return public API.
     */
    return {
        "setScrollRestoration": setScrollRestoration,
        "resetScrollRestoration": resetScrollRestoration
    };
}());

// Namespace fallbacks.
o_global.helper = o_global.helper || {};
o_global.helper.setScrollRestoration = o_util.history.setScrollRestoration;
o_global.helper.resetScrollRestoration = o_util.history.resetScrollRestoration;
